import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';

interface InitialLoadModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function InitialLoadModal({ open, onOpenChange }: InitialLoadModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Please note</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Initial load of the app can take up to 60 seconds.
        </p>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Ok</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
